import { gql, TypedDocumentNode } from "@apollo/client";

import { VcsAgentPoolView } from "./types";

type GetVCSAgentPoolsData = {
  vcsAgentPools: VcsAgentPoolView[];
};

export const GET_VCS_AGENT_POOLS: TypedDocumentNode<GetVCSAgentPoolsData> = gql`
  query GetVCSAgentPools {
    vcsAgentPools {
      id
      name
      description
      config
      deleted
      agentConnections {
        id
        metadata
      }
    }
  }
`;
